/* eslint-disable default-param-last */
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  SETUP_HEADER_PROPS: "HEADER/SETUP_HEADER_PROPS",
  /* SEARCHER */
  RESET_SEARCHER: "HEADER/RESET_SEARCHER",
  //JS LOGIC
  SET_SUGGESTED_INPUTS: "HEADER/SET_SUGGESTED_INPUTS",
  GET_RELATED_PAGES: "HEADER/GET_RELATED_PAGES",
  SET_RELATED_PAGES: "HEADER/SET_RELATED_PAGES",
  // APIS
  SET_SEARCH_ENGINE: "HEADER/SET_SEARCH_ENGINE",
  GET_SEARCHER_INFO: "HEADER/GET_SEARCHER_INFO",
  SET_SEARCHER_INFO: "HEADER/SET_SEARCHER_INFO",
};

export const actions = {
  setupHeaderProps: (data) => ({
    type: types.SETUP_HEADER_PROPS,
    data,
  }),
  /* searcher */
  setSearchEngine: (searchEngine) => ({
    type: types.SET_SEARCH_ENGINE,
    searchEngine,
  }),
  resetSearcher: () => ({ type: types.RESET_SEARCHER }),
  // apis
  getSearcherInfo: () => ({ type: types.GET_SEARCHER_INFO }),
  setSearcherInfo: (info) => ({ type: types.SET_SEARCHER_INFO, info }),
  // js logic
  setSuggestedInputs: (data) => ({ type: types.SET_SUGGESTED_INPUTS, data }),
  getRelatedPages: (query) => ({ type: types.GET_RELATED_PAGES, query }),
  setRelatedPages: (data) => ({ type: types.SET_RELATED_PAGES, data }),
};

const initialState = {
  mainOptions: null,
  navSections: null,
  segmentMenu: null,
  burgerSections: null,
  burgerOptions: null,
  querySuggestedInputs: null,
  inputQuery: "",
  categoriesMatched: null,
  suggestedInputs: null,
  pagesList: null,
  pagesSuggestedList: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      const { header } = action.payload;
      return {
        ...state,
        ...header,
      };
    }
    case types.SETUP_HEADER_PROPS: {
      const headerProps = action.data;
      return {
        ...state,
        ...headerProps,
      };
    }
    case types.SET_SEARCHER_INFO:
      return {
        ...state,
        pagesList: (action.info && action.info.pagesList) || null,
        querySuggestedInputs: null,
        suggestedInputs: (action.info && action.info.suggestedInputs) || null,
        categoryOptions: (action.info && action.info.categoryOptions) || null,
      };
    case types.SET_SUGGESTED_INPUTS: {
      return {
        ...state,
        querySuggestedInputs: [...action.data.querySuggestedInputs],
      };
    }
    case types.RESET_SEARCHER: {
      return {
        ...state,
        categoriesMatched: null,
        querySuggestedInputs: null,
        pagesSuggestedList: null,
      };
    }
    case types.SET_RELATED_PAGES: {
      return {
        ...state,
        inputQuery: action.data.inputQuery,
        categoriesMatched: action.data.categoriesMatched,
        pagesSuggestedList: { ...action.data.pagesList },
      };
    }
    default:
      return state;
  }
}

export default reducer;
